<app-spinner></app-spinner>

<div
  *ngIf="providerDetails && state"
  [ngClass]="containerCssClassName"
  class="booking"
>
  <!-- DESKTOP HEADER -->
  <app-booking-header-desktop></app-booking-header-desktop>

  <!-- MOBILE HEADER -->
  <app-booking-header-mobile></app-booking-header-mobile>

  <div
    *ngIf="bookingStep !== bookingStepsEnum.CONFIRM"
    class="booking__content"
  >
    <div class="booking__content--main">
      <app-booking-card-header></app-booking-card-header>
      <app-booking-summary></app-booking-summary>
      <div [ngSwitch]="bookingStep">
        <div *ngSwitchCase="bookingStepsEnum.SERVICES">
          <ng-container *ngTemplateOutlet="stepServices"></ng-container>
        </div>
        <div *ngSwitchCase="bookingStepsEnum.CALENDAR">
          <ng-container *ngTemplateOutlet="stepCalendar"></ng-container>
        </div>
        <div *ngSwitchCase="bookingStepsEnum.SUBMIT">
          <ng-container *ngTemplateOutlet="stepSubmit"></ng-container>
        </div>
      </div>

      <app-booking-faq class="show-on-mobile"></app-booking-faq>

      <app-booking-footer></app-booking-footer>
    </div>

    <div class="booking__content--sidebar px-0">
      <app-booking-faq class="show-on-desktop"></app-booking-faq>
    </div>
  </div>
</div>

<ng-template #stepServices>
  <app-service-section-v2 class="section-container"></app-service-section-v2>
</ng-template>

<ng-template #stepCalendar>
  <app-calendar-section-v2 class="section-container"></app-calendar-section-v2>
</ng-template>

<ng-template #stepSubmit>
  <app-submit-section class="section-container block"></app-submit-section>
</ng-template>
